import React, {useEffect, useState} from 'react'
import * as Yup from "yup";
import Select from "react-select";
import { connect } from "react-redux";
import {Col, Form, FormGroup, Input, Label, Row, Spinner} from "reactstrap";
import { useForm } from "react-hook-form";


// components
import { ButtonCancel, ButtonSubmit } from "../../buttons/buttonsActions";

// labels
import {
    LB_COMMENTS, LB_DATE, LB_HOUR, LB_PEOPLE, LB_REMINDER, REQUIRED
} from "../../i18n/i18n";

// actions
import { add } from "../../../redux/actions/todoFluye/wishlistActions";

// tools
import {formatStringDate} from "../../../util/DateTools";

// utils
import { wishlistTypes } from "../../../util/WishlistUtils";

// providers
import {hotelActivityProvider} from "../../../providers/hotel/hotelActivityProvider";
import Switch from "react-bootstrap-switch";

const ActivityFormComponent = props => {
    const fbDataBaseId = props.mainState?.app?.fbDataBase?.id
    const udn =  JSON.parse( localStorage.getItem('selectedUdn') )

    const { domainObject } = props.formState
    const { wishlist, handleCancel, handleToggle  } = props

    const [ editMode ] = useState(domainObject != null)

    const [activities, setActivities] = useState([])
    const [activity, setActivity] = useState()
    const [loadingActivities, setLoadingActivities] = useState(true)
    const [activityError, setActivityError] = useState(false)
    const [loadedDefaultActivity, setLoadedDefaultActivity] = useState(false)
    const [ reminder, setReminder ] = useState( domainObject?.reminder || false )

    // load activities
    useEffect(() => {
        const requestData = { id : udn?.id };

        setLoadingActivities(true)
        hotelActivityProvider.getOptions(requestData)
            .then( setActivities )
            .finally( ()=> setLoadingActivities(false) )
    },[])


    // load default activity
    useEffect(() => {
        if(!domainObject)
            return

        if(!loadedDefaultActivity && activities.length >0){
            const selectedActivity = activities.find(i => i.id === domainObject?.activity?.id)
            setActivity(selectedActivity)
            setLoadedDefaultActivity(true)
        }
    } ,[ activities ])



    const validationSchema = Yup.object().shape({
        date: Yup.string().required( REQUIRED ),
        hour: Yup.string().required( REQUIRED ),
        pax: Yup.string().required( REQUIRED ),
    });



    const { register, handleSubmit, errors } = useForm({
        validationSchema: validationSchema,
        defaultValues: {
            date: domainObject ? formatStringDate(domainObject?.date) : null,
            hour: domainObject?.hour,
            pax: domainObject?.pax,
            comments: domainObject?.comments,
            confirmationCode: domainObject?.confirmationCode,
        }
    });

    const onSubmit = (data, _) => {
        if(!activity){
            setActivityError(true)
            return
        }

        let dataRequest = {
            fbDataBase: fbDataBaseId,
            item: {
                ... data,
                type: wishlistTypes.activity.description,
                from:'wishlist',
                reminder,
                activity:{ id:activity?.id },
                wishlist:{ id: wishlist?.id},
            }
        }

        if(domainObject)
            dataRequest.item.id = domainObject?.id

        props.add( dataRequest, handleToggle )
    }

    return <Form onSubmit={handleSubmit(onSubmit)}>
        <Row className={'mb-1em'}>
            <Col className={'wl-modal-title-item'}>
                <img
                    src={require(`../../../assets/images/wishlist/${props?.selectedOption?.icon}`)}
                    alt={props?.selectedOption?.title}
                    width={36}
                    height={36}
                /> &nbsp; { props?.selectedOption?.title }
            </Col>
            <Col>
                <FormGroup>
                    {
                        loadingActivities ?  <> <Spinner animation="border" /> </> : <Select
                            value={ activity }
                            options={ activities }
                            isClearable={ true }
                            isDisabled={ editMode }
                            onChange={ val => setActivity(val) }
                            styles={{ }}
                        />
                    }
                    { activityError && <div className="invalid-feedback" style={{'display':'block'}}>{ REQUIRED }</div>}
                </FormGroup>
            </Col>
        </Row>

        <Row className={'mb-1em'}>
            <Col>
                <FormGroup>
                    <label>
                        <i className={ 'fa fa-calendar' } aria-hidden='true' /> &nbsp;{ LB_DATE }
                    </label>
                    <Input
                        name='date'
                        type='date'
                        /*min={ getDateToFormField(wishlist?.checkIn) }
                        max={ getDateToFormField(wishlist?.checkOut) }*/
                        innerRef={register}
                    />
                    { errors?.date && <div className="invalid-feedback" style={{'display':'block'}}>{errors?.date?.message}</div>}
                </FormGroup>
            </Col>
            <Col>
                <label>
                    <i className={ 'fa fa-clock' } aria-hidden='true' /> &nbsp;{ LB_HOUR }
                </label>
                <FormGroup>
                    <Input
                        name='hour'
                        type="time"
                        innerRef={register}
                    />
                    { errors?.hour && <div className="invalid-feedback" style={{'display':'block'}}>{errors?.hour?.message}</div>}
                </FormGroup>
            </Col>
            <Col>
                <FormGroup>
                    <label>
                        <i className={ 'fa fa-users' } aria-hidden='true' /> &nbsp;{ LB_PEOPLE }
                    </label>
                    <Input
                        name='pax'
                        type='number'
                        min={1}
                        innerRef={register}
                    />
                    { errors?.pax && <div className="invalid-feedback" style={{'display':'block'}}>{errors?.pax?.message}</div>}
                </FormGroup>
            </Col>
        </Row>

        <Row>
            <Col sm={3}>
                <FormGroup>
                    <label>{ LB_REMINDER }</label><br/>
                    <Switch
                        animate={true}
                        offText={"No"}
                        onText={"Si"}
                        value={ reminder }
                        onChange={ () => setReminder(!reminder) }
                    />
                </FormGroup>
            </Col>
        </Row>


        <Row className={'mb-1em'}>
            <Col>
                <label>{ LB_COMMENTS }</label>
                <FormGroup>
                    <Input
                        name='comments'
                        type="textarea"
                        innerRef={register}
                    />
                </FormGroup>
            </Col>
        </Row>

        <Row>
            <Col className="d-flex justify-content-center">
                <div>
                    <ButtonSubmit/>
                    <ButtonCancel onClick={ ()=> handleCancel() }/>
                </div>
            </Col>
        </Row>
    </Form>

}

const mapStateToProps = state => ({
    mainState: state.mainProps,
    formState: state.formProps
})
const mapActionsToProps = ({
    add
})

export default connect(mapStateToProps, mapActionsToProps)(ActivityFormComponent)